import { AnyObject } from '../types';

export function toString(value: AnyObject): string{
  return value.toString();
}
